'use client';

import { assignInlineVars } from "../../../external/@vanilla-extract/dynamic/dist/vanilla-extract-dynamic.esm.js";
import a__default, { memo } from "react";
import { classNames } from "../../utils/styles/classNames.js";
import { colorTheme } from "../color.css.js";
import { getThemedPalette } from "../utils/getThemedPalette.js";
import { bodyFontThemes } from "../bodyFont.css.js";
import { titleFontThemes } from "../titleFont.css.js";
function ChalkThemeProviderComponent({
  primaryColor,
  bodyFont,
  titleFont,
  children
}) {
  if (!bodyFont && !titleFont && !primaryColor) return children;
  const bodyFontTheme = bodyFont && bodyFontThemes[bodyFont];
  const titleFontTheme = titleFont && titleFontThemes[titleFont];
  const customColorTheme = primaryColor && getThemedPalette(primaryColor);
  const customStyle = customColorTheme ? assignInlineVars(colorTheme, customColorTheme) : void 0;
  return /* @__PURE__ */ a__default.createElement(
    "div",
    {
      className: classNames(bodyFontTheme, titleFontTheme),
      style: customStyle
    },
    children
  );
}
const ChalkThemeProvider = (
  // explicit type to workaround `memo` return type incompatibility between v18 and v19
  /* @__PURE__ */ memo(ChalkThemeProviderComponent)
);
export {
  ChalkThemeProvider
};
